import { connect } from 'react-redux';

import Actions from '../../Actions/Creators';
import HSGHeader from './Component/HSGHeader';
import Phi from './../../Phi/Phi'

const mapStateToProps = (state, ownProps) => {
    const userRole =  Phi.User.roles()
    return {
        ...state,
        roleType: userRole && userRole.length && userRole[0].role_type_id,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
      logoutUser: () => dispatch(Actions.logoutUser()), // Action to logout
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HSGHeader)




// WEBPACK FOOTER //
// ./src/Containers/HSGHeaderContainer/index.js